import { Component, ElementRef, ViewChild, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataService } from "../data.service";
import { Router } from "@angular/router";
import { ToastrManager } from "ng6-toastr-notifications";


@Component({
  selector: "app-upload-s3-object",
  templateUrl: "./upload-s3-object.component.html",
  styleUrls: ["./upload-s3-object.component.css"]
})
export class UploadS3ObjectComponent implements OnInit {
  public filename;
  @ViewChild("fileInput")
  fileInput: ElementRef;
  fileDataUri="";
  errorMsg = "";

  constructor(
    private activeModal: NgbActiveModal,
    private dataService: DataService,
    private router: Router,
    private toastr: ToastrManager
  ) {}

  ngOnInit() {}

  onFileSelected(event) {
    console.log(event.target.files[0].name)
    this.filename = event.target.files[0].name
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      this.fileDataUri = JSON.stringify(reader.result);
      // console.log(this.fileDataUri)
    };
  }
  onUpload() {
    if (this.fileDataUri.length > 0) {
      const base64File = this.fileDataUri.split(",")[1];
      // TODO: send to server
      // console.log(base64File);

      this.dataService
        .uploads3Object({
          "data": base64File,
          "bucket": "admin-panel-test",
          "filename": this.filename
        })
        .subscribe(res => {
          console.log(res);
          if(typeof res == 'string'){
            res= JSON.parse(res);
          }
          if (res.Status == 'Success'){
            this.toastr.successToastr("File Uploaded Successfully", "Success!");
            location.reload();
          }else{
            this.toastr.errorToastr(res.Error.message, "oops!");

          }
        });
      this.activeModal.close();
      // this.router.navigate(['/login'])
    }
  }
}
